import { useServicesContext } from "@modules/core/services/services.context"
import { ExploreContentEntity, ExploreProProgramContentEntity } from "@modules/explore/entities/exploreEntity"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMemo } from "react"

export const useBoxExploreSearchContents = (searchTerms: string) => {
  const { exploreApi } = useServicesContext()

  const { data, isLoading, refetch, fetchNextPage, hasNextPage, isFetchingNextPage } = useSuspenseInfiniteQuery({
    queryKey: ["boxExploreSearch", searchTerms],
    queryFn: async ({ pageParam }) => {
      return await exploreApi.searchBoxExplore(searchTerms, {
        page: pageParam,
        size: 20,
      })
    },
    staleTime: 1000 * 60 * 5,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return undefined
      }
      return lastPage.page + 1
    },
  })

  const itemList = useMemo(
    () =>
      data.pages
        .flatMap((page) => page.content)
        .map((content) => ExploreContentEntity.fromDto(content))
        .filter((item) => item instanceof ExploreProProgramContentEntity),
    [data],
  )

  return {
    data: {
      ...data,
      content: itemList,
      totalSize: data.pages[0]?.totalSize ?? 0,
    },
    isLoading,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
